var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMetamask(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    fill: "none",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 100,
    fill: "#233447"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E17726",
    stroke: "#E17726",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.25,
    d: "M154.907 46.765L108.254 80.99l8.674-20.169 37.979-14.055z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#E27625",
    stroke: "#E27625",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.25,
    d: "M47.297 46.765L93.535 81.31 85.276 60.82l-37.98-14.055zm90.817 79.358l-12.415 18.799 26.581 7.255 7.612-25.645-21.778-.409zm-95.755.409l7.566 25.645 26.535-7.255-12.365-18.802-21.736.412z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#E27625",
    stroke: "#E27625",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.25,
    d: "M75.024 94.36l-7.377 11.041 26.303 1.186-.877-28.068L75.024 94.36zm52.145 0l-18.318-16.154-.6 28.385 26.303-1.187-7.385-11.044zm-50.713 50.561l15.92-7.621-13.704-10.586-2.216 18.207zm33.365-7.621l15.874 7.621-2.167-18.207-13.707 10.586z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#D5BFB2",
    stroke: "#D5BFB2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.25,
    d: "M125.699 144.922l-15.878-7.621 1.296 10.224-.142 4.331 14.724-6.934zm-49.24 0l14.766 6.938-.092-4.335 1.247-10.224-15.921 7.621z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#233447",
    stroke: "#233447",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.25,
    d: "M91.499 119.961l-13.196-3.832 9.32-4.244 3.876 8.076zm19.199 0l3.872-8.076 9.37 4.244-13.242 3.832z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#CC6228",
    stroke: "#CC6228",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.25,
    d: "M76.459 144.922l2.309-18.798-14.674.408 12.365 18.39zm46.977-18.798l2.262 18.798 12.411-18.39-14.673-.408zm11.125-20.722l-26.307 1.19 2.447 13.369 3.872-8.076 9.37 4.244 10.618-10.727zm-56.255 10.727l9.32-4.244 3.876 8.076 2.447-13.369-26.303-1.187 10.66 10.724z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#E27525",
    stroke: "#E27525",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.25,
    d: "M67.647 105.402l11.029 21.313-.37-10.586-10.66-10.727zm56.297 10.727l-.415 10.586 11.029-21.31-10.614 10.724zm-29.994-9.537l-2.448 13.369 3.09 15.791.697-20.813-1.339-8.347zm14.304 0l-1.293 8.304.647 20.856 3.09-15.791-2.444-13.369z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.25,
    d: "M110.698 119.962l-3.09 15.791 2.213 1.549 13.704-10.586.415-10.586-13.242 3.832zm-32.395-3.832l.37 10.586 13.703 10.586 2.217-1.549-3.09-15.791-13.2-3.832z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#C0AC9D",
    stroke: "#C0AC9D",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.25,
    d: "M110.975 151.86l.142-4.336-1.201-1.003H92.287l-1.154 1.003.092 4.332-14.766-6.934 5.168 4.198 10.48 7.166h17.948l10.521-7.166 5.123-4.198-14.724 6.938z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#161616",
    stroke: "#161616",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.25,
    d: "M109.823 137.3l-2.217-1.55H94.598l-2.216 1.55-1.243 10.223 1.15-1.004h17.63l1.2 1.004-1.296-10.223z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#763E1A",
    stroke: "#763E1A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.25,
    d: "M156.893 83.225l3.918-18.887-5.904-17.573-45.083 33.083 17.352 14.51 24.503 7.078 5.399-6.255-2.355-1.69 3.74-3.374-2.863-2.19 3.737-2.832-2.444-1.87zM41.389 64.335l3.967 18.89L42.82 85.1l3.783 2.828-2.86 2.19 3.738 3.378-2.355 1.69 5.399 6.248 24.506-7.072 17.348-14.51-45.083-33.086-5.907 17.57z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.25,
    d: "M151.677 101.434l-24.502-7.072 7.381 11.044-11.029 21.31 14.585-.183h21.778l-8.213-25.099zm-76.651-7.072l-24.503 7.072-8.17 25.099h21.74l14.581.183-11.03-21.31 7.382-11.044zm33.227 12.231l1.57-26.744 7.104-19.028H85.274l7.104 19.028 1.57 26.744.6 8.396.047 20.764h13.011l.046-20.764.601-8.396z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetamask);
export default __webpack_public_path__ + "static/media/metamask.c769fdfa.svg";
export { ForwardRef as ReactComponent };